<template>
  <div class="ai-chatbot">
    <ChatbotButton v-if="displayChatbot && !isInline" :isChatbotOpen="isChatbotOpen" />
    <transition name="fade">
      <ChatbotWindow v-if="isChatbotOpen" @close="closeChatbot"/>
    </transition>
  </div>
</template>

<script>
import ChatbotButton from '@/components/ai-chatbot/ChatbotButton.vue';
import ChatbotWindow from '@/components/ai-chatbot/ChatbotWindow.vue';
import ClickOutside from 'vue-click-outside'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  directives: {
    ClickOutside
  },
  components: {
    ChatbotButton,
    ChatbotWindow
  },
  methods: {
    ...mapActions('search', ['initChatbot', 'setChatbot']),
    closeChatbot() {
      this.setChatbot(false);
    }
  },

  computed: {
    ...mapState('search', ['isChatbotOpen', 'chatConfig']),
    ...mapGetters('config', ['features']),

    isInline() {
      return !!this.chatConfig?.inline;
    },

    displayChatbot() {
      const chatbotEnabled = !!this.chatConfig?.isChatOn;
      const storeId = this.$route.query.storeId;
      return chatbotEnabled && this.chatConfig?.stores?.includes(storeId);
    },
  },

  mounted() {
    this.initChatbot();
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms ease, transform 500ms ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.ai-chatbot {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
